import { render, staticRenderFns } from "./InformationsReglementaires.vue?vue&type=template&id=aa9329f4&"
import script from "./InformationsReglementaires.vue?vue&type=script&lang=js&"
export * from "./InformationsReglementaires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports